import {
  useGetTicketSale,
  useCreateTicketSale,
} from 'api-hooks/sale/ticket-sale';
import { KIND, Notification } from 'baseui/notification';
import { NavigationRoutes } from 'common/constants';
import LoadingComponent from 'components/common/loading';
import ErrorViewComponent from 'components/elements/error-view-component';
import FetchWrapperComponent from 'components/elements/fetch-wrapper-component';
import useApprovalableEdit from 'hooks/use-approvalable-edit';
import { DetailContainer, SeparatorVertical } from 'legacy-modules/styles';
import { useRouter } from 'next/router';
import * as React from 'react';
import { NavigationProps } from 'types';

import TicketSaleForm from './components/form';
import { TicketSaleFormType } from './components/form-type';

export type TicketSaleViewParams = {
  id: string;
  defaultValues?: TicketSaleFormType;
};

export default function TicketSaleView(
  props: NavigationProps<NavigationRoutes.TicketSalesView>,
) {
  const { query } = useRouter();
  const id = query?.id as string;
  const { data, error, isLoading, isFetching, refetch } = useGetTicketSale({
    id,
  });

  const { mutateAsync, error: errorMutate } = useCreateTicketSale();

  const ticketSale = data?.data;

  const onResolve = useApprovalableEdit('flight-sales');

  return (
    <FetchWrapperComponent
      onRetry={refetch}
      loadingComponent={<LoadingComponent />}
      error={error}
      errorComponent={
        <DetailContainer>
          <ErrorViewComponent refetch={refetch} />
        </DetailContainer>
      }
      isLoading={isLoading || isFetching}
      component={
        <TicketSaleForm
          {...props}
          renderError={
            !!errorMutate &&
            !!errorMutate.message && (
              <>
                <Notification
                  overrides={{
                    Body: { style: { width: 'auto', wordBreak: 'break-all' } },
                  }}
                  kind={KIND.negative}
                  closeable
                >
                  {() => errorMutate.message}
                </Notification>
                <SeparatorVertical $margin={8} />
              </>
            )
          }
          ticketSale={ticketSale}
          onSubmit={async (input, form) => {
            const result = await mutateAsync(input);
            onResolve(result);
            return result.data;
          }}
        />
      }
    />
  );
}
